import React, { useState, useEffect } from 'react';
import haukeApiService from '../../services/haukeApi';
import '../../assets/css/profil-admin.css';

// FormField Komponente außerhalb definieren um Re-Render Probleme zu vermeiden
const FormField = ({ label, field, type = 'text', readonly = false, data, onInputChange, saving }) => {
  const value = data[field];
  const displayValue = value || '';

  return (
    <tr className="form-row">
      <td className="form-label">{label}</td>
      <td className="form-input">
        {readonly ? (
          <div className="readonly-display">{displayValue || 'Nicht verfügbar'}</div>
        ) : (
          <input
            type={type}
            value={displayValue}
            onChange={(e) => onInputChange(field, e.target.value)}
            disabled={saving}
            placeholder={`${label} eingeben...`}
          />
        )}
      </td>
    </tr>
  );
};

const Online = ({ hofId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    loadData();
  }, [hofId]);

  const loadData = async () => {
    try {
      setLoading(true);
      const response = await haukeApiService.getDirekterzeugerDetails(hofId);
      setData(response.data);
    } catch (err) {
      console.error('Error loading data:', err);
      setError('Fehler beim Laden der Daten');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setData({ ...data, [field]: value });
    setHasChanges(true);
  };

  const showSuccessToast = (message) => {
    const toast = document.createElement('div');
    toast.className = 'success-toast';
    toast.textContent = message;
    document.body.appendChild(toast);
    
    setTimeout(() => {
      document.body.removeChild(toast);
    }, 3000);
  };

  const handleSave = async () => {
    if (!hasChanges) return;

    try {
      setSaving(true);
      const updateData = {
        website: data.website,
        mail_public: data.mail_public,
        facebook: data.facebook,
        instagram: data.instagram
      };
      
      await haukeApiService.updateDirekterzeuger(hofId, updateData);
      setHasChanges(false);
      showSuccessToast('Online-Daten erfolgreich gespeichert!');
    } catch (err) {
      console.error('Error saving:', err);
      alert('Fehler beim Speichern: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    if (hasChanges) {
      if (window.confirm('Änderungen verwerfen?')) {
        loadData();
        setHasChanges(false);
      }
    }
  };



  if (loading) return <div className="webling-loading">Daten werden geladen...</div>;
  if (error) return <div className="webling-error">{error}</div>;
  if (!data) return <div className="webling-error">Keine Daten verfügbar</div>;

  return (
    <div className="webling-container">
      <div className="webling-content">
        <div className="form-section">
          <h3>Website & E-Mail</h3>
          <table className="webling-form">
            <tbody>
              <FormField label="Website" field="website" type="url" data={data} onInputChange={handleInputChange} saving={saving} />
              <FormField label="Öffentliche E-Mail" field="mail_public" type="email" data={data} onInputChange={handleInputChange} saving={saving} />
            </tbody>
          </table>
        </div>

        <div className="form-section">
          <h3>Social Media</h3>
          <table className="webling-form">
            <tbody>
              <FormField label="Facebook" field="facebook" type="url" data={data} onInputChange={handleInputChange} saving={saving} />
              <FormField label="Instagram" field="instagram" type="url" data={data} onInputChange={handleInputChange} saving={saving} />
            </tbody>
          </table>
        </div>

        <div className="form-section">
          <h3>Technische Informationen</h3>
          <table className="webling-form">
            <tbody>
              <tr className="form-row">
                <td className="form-label">Google Maps</td>
                <td className="form-input">
                  <div className="readonly-display">
                    {data.latitude && data.longitude ? (
                      <a 
                        href={`https://maps.google.com/?q=${data.latitude},${data.longitude}`}
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ color: '#007bff', textDecoration: 'none' }}
                      >
                        Karte öffnen ({data.latitude}, {data.longitude})
                      </a>
                    ) : 'Koordinaten nicht verfügbar'}
                  </div>
                </td>
              </tr>
              <tr className="form-row">
                <td className="form-label">Geohash</td>
                <td className="form-input">
                  <div className="readonly-display">{data.geohash || 'Nicht verfügbar'}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="webling-footer">
        <button 
          onClick={handleSave}
          disabled={!hasChanges || saving}
          className="save-button"
        >
          {saving ? 'Speichern...' : 'Speichern'}
        </button>
        <button 
          onClick={handleCancel}
          disabled={saving}
          className="cancel-button"
        >
          Schließen
        </button>
      </div>
    </div>
  );
};

export default Online; 